import React, { useState, useEffect } from "react";
import {
  InputBox,
  SubmitButton,
  TextAreaBox,
  UploadBox,
} from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const CompanyEditForm = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    company_address: "",
    company_email: "",
    web_url: "",
    sales_email: "",
    sales_phone: "",
    research_email: "",
    research_phone: "",
    technical_email: "",
    technical_phone: "",
    tax_percentage: "",
    inc_new: "",
    inc_renewal: "",
    app_desc: "",
    locationmap: "",
    home_video: "",
    facebook_link: "",
    instagram_link: "",
    twitter_link: "",
    linkedin_link: "",
    skype_link: "",
    whatsapp_link: "",
    youtube_link: "",
    telegram_link: "",
    company_logo: null,
    risk_dis_doc: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  // Fetch data from an API or load it dynamically here
  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}settings/company/company-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setFormData(response.data.data); // Adjust this path if the API structure differs
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file uploads
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files[0], // Save the first selected file
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // const phoneRegex = /^\d+$/;
    const phoneRegex = /^\+?\d+$/;
    const taxPercentageRegex = /^\d+(\.\d+)?$/;
    const incentivesRegex = /^\d+(\.\d+)?$/;

    if (
      !emailRegex.test(formData.company_email) ||
      !emailRegex.test(formData.sales_email) ||
      !emailRegex.test(formData.research_email) ||
      !emailRegex.test(formData.technical_email)
    ) {
      showToast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }

    if (
      !phoneRegex.test(formData.sales_phone) ||
      !phoneRegex.test(formData.research_phone) ||
      !phoneRegex.test(formData.technical_phone)
    ) {
      showToast.error("Phone must contain only numbers.");
      setLoading(false);
      return;
    }
    if (!taxPercentageRegex.test(formData.tax_percentage)) {
      showToast.error("Tax Percentage must be a valid number.");
      setLoading(false);
      return;
    }
    if (!incentivesRegex.test(formData.inc_new)) {
      showToast.error("Incentives on new Lead must be a valid number.");
      setLoading(false);
      return;
    }
    if (!incentivesRegex.test(formData.inc_renewal)) {
      showToast.error("Incentives on renewal must be a valid number.");
      setLoading(false);
      return;
    }

    const payload = {
      id: formData.id,
      company_name: formData.company_name,
      company_address: formData.company_address,
      company_email: formData.company_email,
      web_url: formData.web_url,
      sales_email: formData.sales_email,
      sales_phone: formData.sales_phone,
      research_email: formData.research_email,
      research_phone: formData.research_phone,
      technical_email: formData.technical_email,
      technical_phone: formData.technical_phone,
      tax_percentage: formData.tax_percentage,
      inc_new: formData.inc_new,
      inc_renewal: formData.inc_renewal,
      app_desc: formData.app_desc,
      locationmap: formData.locationmap,
      home_video: formData.home_video,
      facebook_link: formData.facebook_link,
      instagram_link: formData.instagram_link,
      twitter_link: formData.twitter_link,
      linkedin_link: formData.linkedin_link,
      skype_link: formData.skype_link,
      whatsapp_link: formData.whatsapp_link,
      youtube_link: formData.youtube_link,
      telegram_link: formData.telegram_link,
      company_logo: formData.company_logo,
      risk_dis_doc: formData.risk_dis_doc,
    };

    try {
      const response = await axios.put(
        `${API_URL}settings/company/update`, // query param instead of path param
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === true) {
        fetchCompany();
        showToast.success(response.data.message);
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <header>{/* Include your header component here */}</header>

      <div id="content">
        <CompanyHeader />
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form method="post">
            <input type="hidden" name="id" value="1" /> {/* Dummy ID */}
            <div className="panel-heading border-0">
              <span className="panel-title">Edit Company Details</span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Reuse the InputBox, TextAreaField, and FileUpload components */}
                <div className="col-md-4 mb-2">
                  <label className="control-label">Company Name</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="company_name"
                    placeholder="Company Name"
                    className="form-control"
                    value={formData.company_name}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Company Address</label>
                  <input
                    type="text"
                    className="form-control"
                    name="company_address"
                    value={formData.company_address}
                    onChange={handleChange}
                    placeholder="Enter Address"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Company Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="company_email"
                    value={formData.company_email}
                    onChange={handleChange}
                    placeholder="Enter Email"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Company URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="web_url"
                    value={formData.web_url}
                    onChange={handleChange}
                    placeholder="Enter Company URL"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Sales Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="sales_email"
                    value={formData.sales_email}
                    onChange={handleChange}
                    placeholder="Enter Sales Email"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Sales Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="sales_phone"
                    value={formData.sales_phone}
                    onChange={handleChange}
                    placeholder="Enter Sales Phone"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Research Email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="research_email"
                    value={formData.research_email}
                    onChange={handleChange}
                    placeholder="Enter Research Email"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Research Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="research_phone"
                    value={formData.research_phone}
                    onChange={handleChange}
                    placeholder="Enter Research Phone"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Technical Email</label>
                  <input
                    type="text"
                    className="form-control"
                    name="technical_email"
                    value={formData.technical_email}
                    onChange={handleChange}
                    placeholder="Enter Technical Email"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Technical Phone</label>
                  <input
                    type="text"
                    className="form-control"
                    name="technical_phone"
                    value={formData.technical_phone}
                    onChange={handleChange}
                    placeholder="Enter Technical Phone"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Tax Percentage</label>
                  <input
                    type="text"
                    className="form-control"
                    name="tax_percentage"
                    value={formData.tax_percentage}
                    onChange={handleChange}
                    placeholder="Enter Tax Percentage"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">
                    Incentives on New Lead
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="inc_new"
                    value={formData.inc_new}
                    onChange={handleChange}
                    placeholder="Enter Incentives On New Lead"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">
                    Incentives On Renewal Lead
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="inc_renewal"
                    value={formData.inc_renewal}
                    onChange={handleChange}
                    placeholder="Enter Incentives On Renewal Lead"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">App Home Description</label>
                  <textarea
                    className="form-control"
                    name="app_desc"
                    value={formData.app_desc}
                    onChange={handleChange}
                    placeholder="Enter App Home Description"
                  ></textarea>
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Location Map</label>
                  <input
                    type="text"
                    className="form-control"
                    name="locationmap"
                    value={formData.locationmap}
                    onChange={handleChange}
                    placeholder="Enter Location Map"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Home Video</label>
                  <input
                    type="text"
                    className="form-control"
                    name="home_video"
                    value={formData.home_video}
                    onChange={handleChange}
                    placeholder="Enter Home Video YouTube URL"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Facebook Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="facebook_link"
                    value={formData.facebook_link}
                    onChange={handleChange}
                    placeholder="Enter Facebook Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Instagram Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="instagram_link"
                    value={formData.instagram_link}
                    onChange={handleChange}
                    placeholder="Enter Instagram Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Twitter Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="twitter_link"
                    value={formData.twitter_link}
                    onChange={handleChange}
                    placeholder="Enter Twitter Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">LinkedIn Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="linkedin_link"
                    value={formData.linkedin_link}
                    onChange={handleChange}
                    placeholder="Enter LinkedIn Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Skype Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="skype_link"
                    value={formData.skype_link}
                    onChange={handleChange}
                    placeholder="Enter Skype Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">WhatsApp Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="whatsapp_link"
                    value={formData.whatsapp_link}
                    onChange={handleChange}
                    placeholder="Enter WhatsApp Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">YouTube Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="youtube_link"
                    value={formData.youtube_link}
                    onChange={handleChange}
                    placeholder="Enter YouTube Link"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">Telegram Link</label>
                  <input
                    type="text"
                    className="form-control"
                    name="telegram_link"
                    value={formData.telegram_link}
                    onChange={handleChange}
                    placeholder="Enter Telegram Link"
                  />
                </div>

                {/* File Uploads */}
                <div className="col-md-4 mb-2">
                  <label className="control-label">Upload Logo Image</label>
                  <input
                    type="file"
                    className="form-control"
                    name="company_logo"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">
                    Risk Disclosure Document
                  </label>
                  <input
                    type="file"
                    className="form-control"
                    name="risk_dis_doc"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default CompanyEditForm;
